var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"logout"}},[_vm._v("saindo...")])
}
var staticRenderFns = []

export { render, staticRenderFns }